import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { DealerDailyCdpSyncSettingsComponent } from 'app/pages/DealerDailyCdpSyncSettingsComponent';
import { CONFIGURE_RESOURCE_DAILY_CDP_SYNC } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useDailyCdpSyncConfigurationPage } from './hooks/useDailyCdpSyncConfigurationPage';

const DailyCdpSyncConfigurationPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useDailyCdpSyncConfigurationPage();

  return (
    <>
      <Helmet>
        <title>Daily CDP Sync</title>
        <meta
          name="description"
          content="Enable or disable daily CDP sync jobs for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Daily CDP Sync"
        headerSubtitle={
          hasDealer ? (
            <DealerPageHeaderEntityInfo
              title={dealerTitle}
              dealerId={dealerId}
            />
          ) : undefined
        }
        contentVariant="centered"
      >
        <DealerDailyCdpSyncSettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  DailyCdpSyncConfigurationPage,
  CONFIGURE_RESOURCE_DAILY_CDP_SYNC,
);
